import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const PrivateRoute = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname;

  const user = localStorage.getItem("user");
  const user_permissions = localStorage.getItem("user_permissions");

  if (!user || !user_permissions) {
    Swal.fire({
      icon: "info",
      text: "Please Login",
      confirmButtonText: "OK",
      allowOutsideClick: false,
    }).then(() => {
      navigate("/login");
    });
    return null;
  }

  const permissions = JSON.parse(user_permissions);

  const hasPermission = permissions.some((permission) => {
    const route = permission.route?.url;
    if (!route) return false;

    const pattern = route
      .replace(/:[^/]+/g, "[^/]+") 
      .replace(/\//g, "\\/");     

    const regex = new RegExp(`^${pattern}$`);
    return regex.test(pathname); 
  });

  if (hasPermission) {
    return children;
  } else {
    Swal.fire({
      icon: "error",
      text: "Denied Access",
      confirmButtonText: "OK",
      timer: 3000,
      timerProgressBar: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      willClose: () => {
        // navigate(-1);
        navigate("/login");
      },
    });
    return null;
  }
};

export default PrivateRoute;
